export default __webpack_public_path__ + "static/media/app-store-panel-1.8e85eacf.png";